import React from 'react';
import './Banana.css';
import { useState, useEffect } from 'react';

const Banana = () => {

  const [isDirty] = useState(false);

  useEffect(() => {

    const onLocationChange = (e) => {
      if (isDirty) {
        document.dispatchEvent(new CustomEvent('modalx', { href: '/banana' }));
      } else {
        document.dispatchEvent(new CustomEvent('navconfirmed', {detail: e}));
      }
    }

    document.addEventListener('popstateb', onLocationChange);

    return () => {
      document.removeEventListener('popstateb', onLocationChange);
    }
    
  }, [isDirty]);

  return (
    <div className='bananaComponent'>
      <div className='contentComponents'>
        Fonanosh Component
      </div>
    </div>
  )
}

Banana.propTypes = {};

Banana.defaultProps = {};

export default Banana;
